module.exports = __webpack_public_path__ + "static/media/Sector1.6ec5d688.jpg";